import { getStorage } from "@/utils/tools"
import { HeaderMenuEnum } from "."
import { DEFAULT_EPID } from "./constant"
import { SystemEnum } from "./enum"
import { isDefaultEpid, isHighAuth, isSuperAdmin } from "@/utils/syetem"

const isDebugMode = () => {
  return localStorage.getItem("isDebug") === 'true'
}
export const PublicPath = [
  '/', // 首页
  '/indicator/detail', // 指标详情
  '/indicator/viewExamine', // 查看审核
]

// 个人空间路径，个人路径不受权限控制
export const PersonalPath = [
  '/cost/list', // 指标详情
]


// 个人菜单 取 menuList key值。固定没有权限限制
export const PersonMenuKeys = ['cost', 'cost/list']

// 权限配置，code，name,路由，多对多。
export const AuthConfig: any[] = [

  // **********系统菜单********
  { path: '/project-center/list', headMenuKey: SystemEnum.SYSTEM, code: '630:project:list:query', name: '指标项目列表' },
  // { path: '/project-center/englist', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标工程列表' },
  // { path: '/project-center/englist/edit', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标工程列表' },
  // 数据字典
  { path: '/dict/professional', headMenuKey: SystemEnum.SYSTEM, code: '', name: '专业信息' },
  { path: '/dict/total', headMenuKey: SystemEnum.SYSTEM, code: '', name: '总体专业' },
  { path: '/dict/project', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程专业' },
  { path: '/dict/sort', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程分类' },
  { path: '/dict/info', headMenuKey: SystemEnum.SYSTEM, code: '', name: '项目信息' },
  { path: '/dict/baseDict', headMenuKey: SystemEnum.SYSTEM, code: '', name: '基础项目信息' },
  { path: '/dict/info2', headMenuKey: SystemEnum.SYSTEM, code: '630:sysdict:project:query', name: '项目信息2' },
  { path: '/dict/projectCategory', headMenuKey: SystemEnum.SYSTEM, code: '630:sysdict:engclass:query', name: '工程分类' },
  { path: '/dict/feature', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程特征' },
  { path: '/dict/feature2', headMenuKey: SystemEnum.SYSTEM, code: '630:sysdict:feature:query', name: '工程特征' },
  { path: '/dict/projectStep', headMenuKey: SystemEnum.SYSTEM, code: '', name: '项目阶段' },
  { path: '/dict/projectSpecial', headMenuKey: SystemEnum.SYSTEM, code: '630:sysdict:major:query', name: '工程专业' },
  { path: '/dict/type', headMenuKey: SystemEnum.SYSTEM, code: '', name: '造价类型' },
  { path: '/dict/template', headMenuKey: SystemEnum.SYSTEM, code: '', name: '指标模板' },

  // 内部数据字典
  {
    path: '/systemDict/professional', headMenuKey: SystemEnum.SYSTEM, code: '', name: '专业信息', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/total', headMenuKey: SystemEnum.SYSTEM, code: '', name: '总体专业', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/project', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程专业', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/sort', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程分类', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/info', headMenuKey: SystemEnum.SYSTEM, code: '', name: '项目信息', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/baseDict', headMenuKey: SystemEnum.SYSTEM, code: '', name: '基础项目信息', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/projectCategory', headMenuKey: SystemEnum.SYSTEM, code: '', name: '项目信息2', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/info2', headMenuKey: SystemEnum.SYSTEM, code: '', name: '项目信息2', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/info3', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程信息', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/feature', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程特征', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/feature2', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程特征', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/projectStep', headMenuKey: SystemEnum.SYSTEM, code: '', name: '项目阶段', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/projectSpecial', headMenuKey: SystemEnum.SYSTEM, code: '', name: '工程专业', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/type', headMenuKey: SystemEnum.SYSTEM, code: '', name: '造价类型', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  {
    path: '/systemDict/template', headMenuKey: SystemEnum.SYSTEM, code: '', name: '指标模板', auth: {
      isSuperAdmin: true,
      isDefaultEpid: true
    }
  },
  // 上海燃气
  { path: '/shry/list', headMenuKey: SystemEnum.SHRY, code: '630:srb:materialmgn:rqwlk', name: '申燃宝' },
  { path: '/shry/fee-standard', headMenuKey: SystemEnum.SHRY, code: '630:srb:sysconfig:ratestd', name: '系统设置' },
  { path: '/shry/unit-price-standard', headMenuKey: SystemEnum.SHRY, code: '630:srb:pricestd:list', name: '单价标准' },
  { path: '/shry/unit-price-standard/edit', headMenuKey: SystemEnum.SHRY, code: '', name: '单价标准编辑' },
  { path: '/shry/project-standard', headMenuKey: SystemEnum.SHRY, code: '630:srb:pricestd:stditem', name: '标准化项目' },
  { path: '/shry/project-standard/edit', headMenuKey: SystemEnum.SHRY, code: '', name: '标准化项目编辑' },

  // 项目模板
  { path: '/template/list', headMenuKey: SystemEnum.YJGL, code: '630:basicdata:project:query', name: '项目模板' },
  { path: '/field/list', headMenuKey: SystemEnum.YJGL, code: '630:basicdata:fieldset:query', name: '字段设置' },
  // { path: '/dict/professional', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:ztzy:query', name: '专业信息' },
  // { path: '/dict/total', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:ztzy:query', name: '总体专业' },
  // { path: '/dict/project', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:gczy:query', name: '工程专业' },
  // { path: '/dict/sort', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:gcfl:query', name: '工程分类' },
  // { path: '/dict/info', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:xmxx:query', name: '项目信息' },
  // { path: '/dict/feature', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:gctz:query', name: '工程特征' },
  // { path: '/dict/type', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:zjlx:query', name: '造价类型' },
  // { path: '/dict/template', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:zbmb:query', name: '指标模板' },
  // { path: '/official-template/list', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:zfzbmb:query', name: '政府指标模板' },
  // { path: '/official-template/open', headMenuKey: HeaderMenuEnum.szzc, code: '630:dict:zfzbmb:open', name: '政府指标模板开放' },

  // 基础清单定额库
  { path: '/inventory/list', headMenuKey: SystemEnum.SYSTEM, code: '630:listlib:qd:query', name: '清单数据' },
  { path: '/inventory/ration', headMenuKey: SystemEnum.SYSTEM, code: '630:listlib:de:query', name: '定额数据' },
  {
    path: '/inventory/laborMaterialsMachinery',
    code: '630:listlib:rcj:query',
    headMenuKey: SystemEnum.SYSTEM,
    name: '人材机数据',
  },

  // 成本科目库
  { path: '/cost/list', headMenuKey: SystemEnum.SYSTEM, code: '', name: '成本科目库' },
  { path: '/cost/split', headMenuKey: SystemEnum.SYSTEM, code: '', name: '自动拆分方案' },

  // 项目模板
  // { path: '/template/list', headMenuKey: HeaderMenuEnum.jcsj, code: '630:basicnf:projtempl:query', name: '项目模板' },
  // { path: '/field/list', headMenuKey: HeaderMenuEnum.jcsj, code: '', name: '字段设置' },
  // 后台日志
  { path: '/log/list', headMenuKey: SystemEnum.YJGL, code: '630:syslog:oplog:query', name: '操作日志' },

  // **********指标********

  // 造价指标-简报看板
  { path: '/indicator-brief/summary', headMenuKey: SystemEnum.ZBGL, code: '630:dashbord:query', name: '简报看板' },

  // 造价指标-指标工程列表
  { path: '/indicator/englist', headMenuKey: SystemEnum.ZBGL, code: '630:indcoll:cost:query', name: '指标工程列表' },
  { path: '/indicator/englist/edit', headMenuKey: SystemEnum.ZBGL, code: '630:indcoll:cost:update', name: '指标工程列表' },
  { path: '/indicator/operlog', headMenuKey: SystemEnum.ZBGL, code: '630:logmgn:oplog:mgn', name: '操作日志' },
  { path: '/indicator/list', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标项目列表' },
  { path: '/indicator/officialTemplate', headMenuKey: SystemEnum.ZBGL, code: '', name: '政府指标模板' },

  // 指标查询
  { path: '/indicator-view/km', headMenuKey: SystemEnum.ZBGL, code: '630:indquery:subj:query', name: '科目指标' },
  { path: '/indicator-view/eng', headMenuKey: SystemEnum.ZBGL, code: '630:indquery:project:query', name: '工程指标' },
  { path: '/indicator-view/qdzhdj', headMenuKey: SystemEnum.ZBGL, code: '630:indquery:qd:query', name: '清单综合单价' },
  { path: '/indicator-view/glj', headMenuKey: SystemEnum.ZBGL, code: '630:indquery:rcj:query', name: '工料机价格' },

  // 指标应用
  { path: '/indicator-apply/costControlCompare', headMenuKey: SystemEnum.ZBGL, code: '630:indapply:feectrl:query', name: '费控对比' },
  { path: '/indicator-apply/costControlCompare/edit', headMenuKey: SystemEnum.ZBGL, code: '', name: '对比设置' },
  { path: '/indicator-apply/costControlCompare/result', headMenuKey: SystemEnum.ZBGL, code: '', name: '对比结果' },
  { path: '/indicator-apply/standard', headMenuKey: SystemEnum.ZBGL, code: '630:indapply:std:query', name: '指标标准' },
  { path: '/indicator-apply/standard/edit', headMenuKey: SystemEnum.ZBGL, code: '', name: '编辑标准' },
  { path: '/indicator-apply/application', headMenuKey: SystemEnum.ZBGL, code: '630:indcoll:report:query', name: '指标应用列表' },
  { path: '/indicator-apply/report', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标报表' },

  // 投资估算
  { path: '/investment/estimate', headMenuKey: SystemEnum.ZBGL, code: '630:indapply:invest:query', name: '投资估算' },
  { path: '/investment/estimate/edit', headMenuKey: SystemEnum.ZBGL, code: '630:indapply:invest:update', name: '投资估算' },
  // 合约规划
  { path: '/cost-control/contract-plan', headMenuKey: SystemEnum.ZBGL, code: '630:contractinst:query', name: '合约规划' },
  { path: '/cost-control/contract-plan/edit', headMenuKey: SystemEnum.ZBGL, code: '630:contractinst:update', name: '合约规划编辑' },


  {
    path: '/indicator/officialTemplate2', headMenuKey: SystemEnum.ZBGL, code: '630:indtmpl:reporttmpl:query', name: '政府指标模板'
  },
  { path: '/indicator/official-template/open', headMenuKey: SystemEnum.ZBGL, code: '', name: '政府指标模板开放' },
  { path: '/official-template/newSetting', headMenuKey: SystemEnum.ZBGL, code: '', name: '政府指标模板设置' },
  { path: '/indicator/edit', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标编辑' },
  { path: '/indicator/add', headMenuKey: SystemEnum.ZBGL, code: '', name: '新增造价类型' },
  // 指标报表
  // 项目对比
  { path: '/indicator/singlecompare', headMenuKey: SystemEnum.ZBGL, code: '', name: '单项目对比' },
  { path: '/indicator/multicompare', headMenuKey: SystemEnum.ZBGL, code: '', name: '多项目对比' },
  { path: '/indicator/reviewSingle', headMenuKey: SystemEnum.ZBGL, code: '', name: '多项目对比' },
  { path: '/indicator/reviewMulti', headMenuKey: SystemEnum.ZBGL, code: '', name: '多项目对比' },
  // 待审核指标列表
  { path: '/indicator/reviewList', headMenuKey: SystemEnum.ZBGL, code: '', name: '待审核指标列表' },
  { path: '/indicator/examine', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标审核' },
  // { path: '/indicator/report', headMenuKey: SystemEnum.ZBGL, code: '', name: '' },
  { path: '/indicator-apply/report', headMenuKey: SystemEnum.ZBGL, code: '', name: '' },
  // 数据字典
  { path: '/zjDict/info3', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:project:query', name: '工程信息' },
  { path: '/zjDict/gsgc', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:estproj:query', name: '估算工程信息' },
  { path: '/zjDict/subjectAttr', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:itemattr:query', name: '科目属性' },
  { path: '/zjDict/indicatorStandard', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:std:query', name: '指标标准' },
  { path: '/zjDict/costingPhase', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:coststage:query', name: '造价阶段' },
  { path: '/zjDict/invoiceType', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:invoice:query', name: '单据类型' },
  // { path: '/zjDict/allocationRules', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:allorule:query', name: '分摊规则' },
  // 造价-系统设置
  { path: '/zj-system/allocationRules', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:allorule:query', name: '分摊规则' },
  { path: '/zj-system/verifySetting', headMenuKey: SystemEnum.ZBGL, code: '630:dict2:checksetting:query', name: '校验设置' },
  { path: '/zj-system/fee-standard', headMenuKey: SystemEnum.ZBGL, code: '630:indapply:ratestd:query', name: '费率标准' },
  { path: '/zj-system/fee-standard/edit', headMenuKey: SystemEnum.ZBGL, code: '', name: '编辑标准' },
  { path: '/zj-system/adjust-factor', headMenuKey: SystemEnum.ZBGL, code: '630:sysconfig:adjustfactor:query', name: '调差因子' },

  // ...(isHighAuth() ? [{ path: '/systemData/glj', headMenuKey: SystemEnum.ZBGL, code: '', name: '鲁班工料机' }] : []),
  { path: '/systemData/glj', headMenuKey: SystemEnum.ZBGL, code: '', name: '鲁班工料机' },
  { path: '/systemData/unit', headMenuKey: SystemEnum.ZBGL, code: '', name: '系统单位' },
  { path: '/systemData/unitChange', headMenuKey: SystemEnum.ZBGL, code: '', name: '单位转换' },
  { path: '/systemData/collectTemplateRules', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标模板规则' },
  { path: '/systemData/collectTemplateRules/edit', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标模板规则' },
  // 企业指标
  { path: '/enterprise/project', headMenuKey: SystemEnum.ZBGL, code: '', name: '整体工程指标' },
  { path: '/enterprise/single', headMenuKey: SystemEnum.ZBGL, code: '', name: '单项工程指标' },
  { path: '/enterprise/unit', headMenuKey: SystemEnum.ZBGL, code: '', name: '单位工程指标' },
  { path: '/enterprise/inventory', headMenuKey: SystemEnum.ZBGL, code: '', name: '清单综合单价' },
  { path: '/enterprise/material', headMenuKey: SystemEnum.ZBGL, code: '', name: '工料价格指标' },

  // 基础数据维护
  { path: '/dict/zjzb', headMenuKey: SystemEnum.ZBGL, code: '', name: '数据字典' },
  { path: '/inventory', headMenuKey: SystemEnum.ZBGL, code: '', name: '基础清单定额库' },
  { path: '/application-template', headMenuKey: SystemEnum.ZBGL, code: '', name: '指标指标模板' },
  { path: '/indicator/collectorTemplate', headMenuKey: SystemEnum.ZBGL, code: '630:indtmpl:colltmpl:query', name: '指标模板2' },
  { path: '/indicator/collectorTemplate/edit', headMenuKey: SystemEnum.ZBGL, code: '630:indtmpl:colltmpl:update', name: '指标模板2' },
  { path: '/indicator/contractTemplate', headMenuKey: SystemEnum.ZBGL, code: '630:contracttmpl:query', name: '合约模板' },
  { path: '/indicator/contractTemplate/edit', headMenuKey: SystemEnum.ZBGL, code: '630:contracttmpl:update', name: '合约模板' },
  // 政府发布指标模板
  { path: '/official-template/list', headMenuKey: SystemEnum.ZBGL, code: '', name: '政府指标模板' },
  { path: '/official-template/open', headMenuKey: SystemEnum.ZBGL, code: '', name: '政府指标模板开放' },
  { path: '/official-template/setting', headMenuKey: SystemEnum.ZBGL, code: '', name: '政府指标模板设置' },
  // { path: '/field/list',headMenuKey:SystemEnum.jcsj, code: '', name: '字段设置' },

  // 项目登记
  { path: '/cloud-project/list', headMenuKey: SystemEnum.YJGL, code: '630:perfmgt:project:query', name: '项目登记' },
  { path: '/cloud-project/analysis', headMenuKey: SystemEnum.YJGL, code: '630:sas:sas:query', name: '项目分析' },
  { path: '/cloud-project/dict-list', headMenuKey: SystemEnum.YJGL, code: '630:basicdata:dict:query', name: '数据字典' },
  { path: '/cloud-project/code-rule', headMenuKey: SystemEnum.YJGL, code: '630:basicdata:codingrule:query', name: '编码规则' },
  // 合作单位
  { path: '/cloud-project/base-partner', headMenuKey: SystemEnum.YJGL, code: '630:basicdata:partner:query', name: '合作单位' },
  // 资料列表
  { path: '/cloud-project/document-list', headMenuKey: SystemEnum.YJGL, code: '630:perfmgt:project.attachment:query', name: '资料列表' },

  /* 资料文档 */
  { path: '/document/engList', headMenuKey: SystemEnum.ZLWD, code: '630:doc:prep:proj:list', name: '资料工程' },
  { path: '/document/engList/detail', headMenuKey: SystemEnum.ZLWD, code: '630:doc:prep:proj:view', name: '资料工程详情' },
  { path: '/document/engList/dir', headMenuKey: SystemEnum.ZLWD, code: '630:doc:prep:proj:view', name: '资料工程目录' },
  { path: '/document/enterpriseInfo', headMenuKey: SystemEnum.ZLWD, code: '630:doc:baseinfo:ep:list', name: '企业信息' },
  { path: '/document/personInfo', headMenuKey: SystemEnum.ZLWD, code: '630:doc:baseinfo:pe:list', name: '人员信息' },
  { path: '/document/domainList', headMenuKey: SystemEnum.ZLWD, code: '630:doc:field:field:list', name: '字段域' },
  // 模板管理
  { path: '/document/templateList', headMenuKey: SystemEnum.ZLWD, code: '630:doc:tmpl:doc:list', name: '文档模板' },
  { path: '/document/dirList', headMenuKey: SystemEnum.ZLWD, code: '630:doc:tmpl:dir:list', name: '文档目录' },
  { path: '/document/packageTemplateList', headMenuKey: SystemEnum.ZLWD, code: '630:doc:tmpl:pkg:list', name: '资料包模板' },
  { path: '/document/packageTemplateList/view', headMenuKey: SystemEnum.ZLWD, code: '', name: '资料包视图' },
  // 基础信息
  { path: '/document/enterpriseInfo', headMenuKey: SystemEnum.ZLWD, code: '630:doc:baseinfo:ep:list', name: '企业信息' },
  { path: '/document/personInfo', headMenuKey: SystemEnum.ZLWD, code: '630:doc:baseinfo:pe:list', name: '人员信息' },
  // 字典信息
  { path: '/document/engDict', headMenuKey: SystemEnum.ZLWD, code: '630:doc:dict:dict:list', name: '工程类型' },
  { path: '/document/projectInfoDict', headMenuKey: SystemEnum.ZLWD, code: '630:doc:dict:dict:list', name: '项目属性' },
  { path: '/document/enterpriseInfoDict', headMenuKey: SystemEnum.ZLWD, code: '630:doc:dict:dict:list', name: '企业属性' },
  { path: '/document/personInfoDict', headMenuKey: SystemEnum.ZLWD, code: '630:doc:dict:dict:list', name: '人员属性' },
  { path: '/document/signDict', headMenuKey: SystemEnum.ZLWD, code: '630:doc:dict:dict:list', name: '签名身份' },
  // 测试
  { path: '/test', code: '', name: '测试' }
]
